class OnboardingChecklistController {
  constructor(
    Authentication,
    PersonaCollection,
    LaborCostSettings,
    EventCollection,
    $rootScope,
    $state
  ) {
    'ngInject';

    Object.assign(this, {
      Authentication,
      PersonaCollection,
      LaborCostSettings,
      EventCollection,
      $rootScope,
      $state,
    });
  }

  $onInit() {
    this.init();
    this.laborCostDataLoaded = false;
    this.autoOpenOnboarding = false;
  }

  $onDestroy() {
    this.educationHideListener?.();
  }

  async init() {
    await this.Authentication.userLoaded;
    await this.PersonaCollection.personaCollectionLoaded;

    this.educationHideListener = this.$rootScope.$on('education:hide', (event, { config }) => {
      if (config.name === 'PUBLISH_SCHEDULE') {
        this.autoOpenOnboarding = true;
      }
    });
  }

  saveLaborCostSettingsInAngular = (settings) => {
    if (this.LaborCostSettings.noAccess) {
      return;
    }

    this.LaborCostSettings.save(settings);
  };

  addPersonaCollectionUser = (user) => this.PersonaCollection.addUser(user);
  updateOrgSettings = (settings) =>
    (this.Authentication.user.orgSettings = {
      ...this.Authentication.user.orgSettings,
      ...settings,
    });
  editPersonaCollectionGroup = (group) => this.PersonaCollection.editGroup(group);
  onUpdateClientFlags = (clientFlags) => {
    this.$rootScope.$emit('sdk:client-flags:save', clientFlags);
  };
  openCreateShiftModal = () => this.$rootScope.$emit('sdk:shift:create');
  showPublishShiftModal = () => this.$rootScope.$emit('sdk:shift:publish-modal');
  showPublishShiftTooltip = () => this.$rootScope.$emit('sdk:shift:publish-tooltip');
  navigateToReports = () => this.$state.go('reports');
  navigateToSchedule = (date) =>
    this.$state.go('shifts', { mode: 'week', tab: 'fullschedule', date }, { reload: true });
}

export default {
  template: `
    <r-onboarding-checklist-guard
      current-user="ctrl.Authentication.user"
      positions="ctrl.PersonaCollection.positions"
      locations="ctrl.PersonaCollection.locations"
      employees="ctrl.PersonaCollection.users"
      client-flags="ctrl.Authentication.user.settings.clientFlags"
      save-labor-cost-settings-in-angular="ctrl.saveLaborCostSettingsInAngular(settings)"
      personas-dict="ctrl.PersonaCollection.personasDict"
      org-locations-count="ctrl.PersonaCollection.locations.length"
      add-persona-collection-user="ctrl.addPersonaCollectionUser(user)"
      open-create-shift-modal="ctrl.openCreateShiftModal()"
      navigate-to-reports="ctrl.navigateToReports()"
      navigate-to-schedule="ctrl.navigateToSchedule(date)"
      update-org-settings="ctrl.updateOrgSettings(settings)"
      edit-persona-collection-group="ctrl.editPersonaCollectionGroup(group)"
      on-update-client-flags="ctrl.onUpdateClientFlags(clientFlags)"
      is-loaded="ctrl.$rootScope.scheduleLoading"
      show-publish-shift-modal="ctrl.showPublishShiftModal()"
      show-publish-shift-tooltip="ctrl.showPublishShiftTooltip()"
      all-events="ctrl.EventCollection.allEvents"
      org-settings="ctrl.Authentication.user.orgSettings"
      auto-open-onboarding="ctrl.autoOpenOnboarding"
      update-wages="ctrl.PersonaCollection.updateWages(wages)">
    </r-onboarding-checklist-guard>
    `,
  controller: OnboardingChecklistController,
  controllerAs: 'ctrl',
};
